import { axiosGet } from '@/api/handlers';
import { ReportLocalGovernmentFundsTableFundOwnerForLocalGovernmentModel } from '@/features/mold/models';
import { convertLocalGovernmentFundTableFundOwnerForLocalGovernmentToCsv } from '@/features/mold/utils/local-government-fund/tableFundOwnerForLocalGovernment';
import { t } from '@/i18n';
import { EMPTY_DATA_ERROR } from '@/utils';
import { downloadCsv } from '@/utils';

export const fetchLocalGovernmentFundIndividualReport = async (id: string) => {
  const localGovernmentFundIndividualReport = await axiosGet(
    `/api/projects/${id}/local-government-fund-individual-report/`,
  );

  return ReportLocalGovernmentFundsTableFundOwnerForLocalGovernmentModel.parse(
    localGovernmentFundIndividualReport,
  );
};

const _downloadFundOwnerForLocalGovernmentReportCsv = async ({
  id,
  fiscalYear,
  projectName,
  isDebugMode,
}: {
  id: string;
  fiscalYear: number;
  projectName: string;
  isDebugMode: boolean;
}) => {
  const reportData = await fetchLocalGovernmentFundIndividualReport(id);

  if (!reportData.data.length) {
    throw new Error(EMPTY_DATA_ERROR);
  }

  const csvData =
    convertLocalGovernmentFundTableFundOwnerForLocalGovernmentToCsv({
      fiscalYear,
      reports: reportData,
      isDebugMode,
    });

  downloadCsv(
    csvData,
    t('report-fund-owner-for-local-government-individual-table-title', {
      year: fiscalYear,
      projectName,
    }),
  );
};
